import { render } from "./Sidebar.vue?vue&type=template&id=37fe5554&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=37fe5554&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37fe5554"

export default script